export default{
  baseUrl: process.env.NODE_ENV === 'production' ? location.origin : "http://localhost/tropicana-slim/public",
}